<template>
  <div id="modal">
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog" role="document" :class="size">
        <div class="modal-content">
          <div class="modal-header">
            <slot name="header"></slot>
            <button type="button" class="close pointer" aria-label="Close" @click="$emit('closeModal')">
              <span aria-hidden="true">
                &times;
              </span>
            </button>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" @click="$emit('closeModal')">
              <i class="fa fa-close"></i> Close
            </button>
            <slot name="buttons"></slot>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>
<script>
export default {
  name: "Modal",
  props: ["size"]
};
</script>



// WEBPACK FOOTER //
// src/components/Modal.vue